import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import api from '../../utils/axios';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

// Un paso de la migración (vista previa / ejecutar con confirmación) que corre en segundo plano en /migraciones/{tipo}.
export const MigracionPaso = ({ tipo, prefijo, textoEjecutar, bloqueo, children }) => {
  const [run, setRun] = useState(null);
  const [confirmacion, setConfirmacion] = useState('');
  const timer = useRef(null);

  const seguir = (id) => {
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      try {
        const { data } = await api.get(`/migraciones/${tipo}/${id}`);
        setRun(data);
        if (data.estado === 'EN_CURSO') seguir(id);
        else if (data.estado === 'ERROR') toast.error(data.error || 'La migración falló');
      } catch (e) {
        seguir(id);
      }
    }, 3000);
  };

  useEffect(() => {
    api.get(`/migraciones/${tipo}`).then(async ({ data }) => {
      if (data[0]) {
        const r = await api.get(`/migraciones/${tipo}/${data[0].id}`);
        setRun(r.data);
        if (r.data.estado === 'EN_CURSO') seguir(r.data.id);
      }
    }).catch(() => {});
    return () => clearTimeout(timer.current);
  }, [tipo]);

  const iniciar = async (modo) => {
    try {
      const { data } = await api.post(`/migraciones/${tipo}`, { modo, confirmacion: modo === 'ejecutar' ? confirmacion : undefined });
      setRun({ ...data, inicio: new Date().toISOString() });
      setConfirmacion('');
      seguir(data.id);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'No se pudo iniciar');
    }
  };

  const enCurso = run?.estado === 'EN_CURSO';
  const previewLista = run?.estado === 'LISTO' && run?.modo === 'preview';
  const motivo = previewLista && bloqueo ? bloqueo(run.resultado) : null;
  return (
    <div className="space-y-3" data-testid={`${prefijo}-paso`}>
      <div className="flex flex-wrap items-center gap-2">
        <Button onClick={() => iniciar('preview')} disabled={enCurso} data-testid={`${prefijo}-preview`}>
          {enCurso ? <Loader2 size={16} className="mr-2 animate-spin" /> : null} Vista previa
        </Button>
        {previewLista && motivo && <p className="text-xs text-amber-700 max-w-xl" data-testid={`${prefijo}-bloqueado`}>{motivo}</p>}
        {previewLista && !motivo && (
          <>
            <Input value={confirmacion} onChange={(e) => setConfirmacion(e.target.value)} placeholder="Escribí EJECUTAR"
              className="w-44" data-testid={`${prefijo}-confirmacion`} />
            <Button variant="destructive" disabled={confirmacion !== 'EJECUTAR'} onClick={() => iniciar('ejecutar')}
              data-testid={`${prefijo}-ejecutar`}>{textoEjecutar}</Button>
          </>
        )}
      </div>
      {enCurso && <p className="text-sm text-slate-500" data-testid={`${prefijo}-en-curso`}>Procesando… ({run.modo})</p>}
      {run?.estado === 'ERROR' && <p className="text-sm text-red-600" data-testid={`${prefijo}-error`}>{run.error}</p>}
      {run?.resultado && children(run.resultado)}
    </div>
  );
};
